import { HighlightedOption, TagData } from '../types';

type ColorVariant = 'highlight' | 'indicator' | 'dot';

const TAG_COLORS: Record<
  ColorVariant,
  {
    default: string;
    status: Record<string, string>;
    process: Record<string, string>;
    origin: Record<string, string>;
  }
> = {
  highlight: {
    default: '#add8e6',
    status: { valid: '#b4ffa9', invalid: '#f49394', unvalidated: '#ffe489' },
    process: { draft: '#dfcad9', need_attention: '#fad1ab', verified: '#d9c3b8', approved: '#bdd9b9' },
    origin: { human: '#76b8b2', ai: '#8B91DA' },
  },
  indicator: {
    default: '#62a4b9',
    status: { valid: '#244320', invalid: '#6f2526', unvalidated: '#6f5836' },
    process: { draft: '#593e51', need_attention: '#734316', verified: '#543929', approved: '#244320' },
    origin: { human: '#324f4d', ai: '#222659' },
  },
  dot: {
    default: '#62a4b9',
    status: { valid: '#70da74', invalid: '#e15758', unvalidated: '#ffc700' },
    process: { draft: '#b07ba1', need_attention: '#f28d2c', verified: '#9f6a4d', approved: '#59a14f' },
    origin: { human: '#c8e3e0', ai: '#bfc2f9' },
  },
};

const getTagColor = (variant: ColorVariant, option: HighlightedOption, tagData: TagData | undefined): string => {
  const colors = TAG_COLORS[variant];
  if (!tagData) return colors.default;
  if (option === 'status') return colors.status[tagData.validationStatus ?? ''] ?? colors.default;
  if (option === 'process') return colors.process[tagData.status ?? ''] ?? colors.default;
  if (option === 'tagger') return colors.origin[tagData.origin ?? ''] ?? colors.default;
  return colors.default;
};

export const getTagHighlightColor = (option: HighlightedOption, tagData: TagData | undefined): string => getTagColor('highlight', option, tagData);

export const getTagIndicatorColor = (option: HighlightedOption, tagData: TagData | undefined): string => getTagColor('indicator', option, tagData);

export const getTagDotColor = (option: HighlightedOption, tagData: TagData | undefined): string => getTagColor('dot', option, tagData);
